import { DSTIRecord } from "../../../../models/DSTI/site-dsti-list.interface";
import { Card } from "primereact/card";
import { s3GetUrl } from "../../../../service/s3Service";
import { useEffect, useState } from "react";
import { useS3Service } from "../../../../hooks/useS3Service";
import { RouteComponentProps } from "../../../../models/RouteComponent";
import DisplayPhoto from "./DisplayPhoto";

interface DSTIPhotosProps {
  dstiDetails?: DSTIRecord;
  restProps: RouteComponentProps;
}

function DSTIPhotos({ dstiDetails, restProps }: DSTIPhotosProps) {
  const [photoUrls, setPhotoUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const { openFileInNewTab } = useS3Service();

  useEffect(() => {
    const fetchPhotoUrls = async () => {
      if (dstiDetails?.photo && dstiDetails.photo.length > 0) {
        setLoading(true);
        try {
          const urls = await Promise.all(
            dstiDetails.photo.map(async photoPath => {
              return await s3GetUrl(photoPath);
            })
          );
          setPhotoUrls(urls);
        } catch (error) {
          console.error("Error fetching photo URLs:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchPhotoUrls();
  }, [dstiDetails?.photo]);

  return (
    <>
      {loading ? (
        <Card>Loading photos...</Card>
      ) : photoUrls.length > 0 ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "1rem",
          }}
        >
          {photoUrls.map((url, index) => {
            return (
              <DisplayPhoto
                key={index}
                url={url}
                index={index}
                onClick={() => {
                  if (dstiDetails?.photo && dstiDetails.photo[index]) {
                    openFileInNewTab(`Photo-${index + 1}`, dstiDetails.photo[index]);
                  }
                }}
              />
            );
          })}
        </div>
      ) : (
        <Card>No progress photo&apos;s available</Card>
      )}
    </>
  );
}

export default DSTIPhotos;
